export default "__VITE_ASSET__DnYk$9Zc__"